import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import { parseUser } from '@/shared/converters/userConverters';
import User from '@/shared/models/User';
import { FullName } from '@/shared/models/common';
import { isPresent } from '@/shared/utils/typescript';
import Vehicle from '@/vehicle/models/Vehicle';
import TaskStatus from '../constants/TaskStatus';
import Task from '../models/Task';
import { parseAppointment } from './appointmentConverters';
import { parseKeydrop } from './keydropConverters';
import { parseTaskDossier } from './taskDossierConverters';

export const ABSTRACT_SCHEMA = {
  description: (data: any) => data.taskMessage ?? data.message ?? data.description,
  externalReference: (data: any) => data.externalReference || data.dmsReference,
  vehicle: parseTaskVehicle,
  dossier: parseTaskDossier,
  contactNames: (data: any) => parseContactNames(data.dossierContacts ?? data.contacts),
  createdBy: (data: any) => User.withFullName(data.createdBy),
};

const SCHEMA = {
  ...ABSTRACT_SCHEMA,
  id: 'id',
  outletId: 'moboOutletId',
  type: 'type',
  bookingId: 'internalId',
  keydrop: (data: any) => parseKeydrop(data.contentJson ? JSON.parse(data.contentJson) : null),
  isTaskOfCurrentIdentity: 'isTaskOfCurrentIdentity',
  isGroupTask: 'isGroupTask',
  isResolvable: 'isResolvable',
  status: (data: any) => data.resolvedBy ? TaskStatus.RESOLVED : TaskStatus.OPEN,
  createdOn: (data: any) => parseMoment(data.createdOn),
  deadline: (data: any) => parseMoment(data.deadline),
  ownedBy: (data: any) => User.withIdFullNameAndAvatar(data.ownedById, data.ownedByName, data.ownedByAvatar),
  dossierOwnedBy: (data: any) => isPresent(data.assignedTo) ? User.withId(data.assignedTo) : null,
  resolvedBy: (data: any) => parseUser(data.resolvedBy),
  appointment: parseAppointment,
};

export function parseTaskVehicle(data: any): Vehicle | null {
  const registrationNumber = data.objectReference ?? data.registrationNumber;
  const modelDescription = data.modelDescription;
  if (!registrationNumber && !modelDescription) return null;
  return Vehicle.withData({ registrationNumber, modelDescription });
}

export function parseTask(data: any): Task | null {
  return parseEntity(data, SCHEMA, Task);
}

export function parseTasks(data: any): Array<Task> {
  return parseEntities(data, parseTask);
}

export function parseContactNames(data: any): Array<FullName> {
  if (typeof data === 'string') return data.split(',');
  if (Array.isArray(data)) return data;
  return [];
}